import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnInstancesUrl } from './paths';
import type { AbnInstancesResponse } from './types';

export async function getAbnInstances() {
  const response = await api.executeGetRequest<ObjectResponse<AbnInstancesResponse>>(abnInstancesUrl());

  return response.data;
}
